import { render } from "./ChapterInfo.vue?vue&type=template&id=3089314a"
import script from "./ChapterInfo.vue?vue&type=script&lang=js"
export * from "./ChapterInfo.vue?vue&type=script&lang=js"

import "./ChapterInfo.vue?vue&type=style&index=0&id=3089314a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__